(function () {
  'use strict';

  if (window.AlvornStorefrontEventsInitialized) return;
  window.AlvornStorefrontEventsInitialized = true;

  function analyticsProcessingAllowed() {
    try {
      return Boolean(
        window.Shopify
        && Shopify.customerPrivacy
        && typeof Shopify.customerPrivacy.analyticsProcessingAllowed === 'function'
        && Shopify.customerPrivacy.analyticsProcessingAllowed()
      );
    } catch (error) {
      return false;
    }
  }

  function publish(name, data) {
    if (!analyticsProcessingAllowed()) return false;
    var payload = data || {};

    try {
      document.dispatchEvent(new CustomEvent(name, { detail: payload }));
    } catch (error) {}

    try {
      if (window.Shopify && Shopify.analytics && typeof Shopify.analytics.publish === 'function') {
        var result = Shopify.analytics.publish(name, payload);
        if (result && typeof result.catch === 'function') result.catch(function () {});
      }
    } catch (error) {}

    return true;
  }

  function safeToken(token) {
    return /^[A-Za-z0-9_-]{8,200}$/.test(token || '') ? token : null;
  }

  function safeIdentity(identity) {
    return /^[A-Za-z0-9_-]{1,200}$/.test(identity || '') ? identity : null;
  }

  function pendingKey(kind, identity) {
    return 'alvorn:pending-success:' + kind + ':' + identity;
  }

  function formIdentity(form) {
    if (form.matches('.email-signup__form')) {
      var source = form.closest('[data-alvorn-newsletter-source]');
      var sourceId = source ? source.getAttribute('data-alvorn-newsletter-source') : null;
      return safeIdentity(sourceId) ? { kind: 'newsletter', identity: sourceId } : null;
    }
    if (form.matches('.alvorn-waitlist-product__form')) {
      var product = form.closest('[data-alvorn-waitlist-product-id]');
      var productId = product ? product.getAttribute('data-alvorn-waitlist-product-id') : null;
      return safeIdentity(productId) ? { kind: 'waitlist', identity: productId } : null;
    }
    return null;
  }

  function successIdentity(element) {
    if (element.hasAttribute('data-alvorn-newsletter-success')) {
      var source = element.closest('[data-alvorn-newsletter-source]');
      var sourceId = source ? source.getAttribute('data-alvorn-newsletter-source') : null;
      return safeIdentity(sourceId) ? { kind: 'newsletter', identity: sourceId } : null;
    }
    var productId = element.getAttribute('data-product-id');
    return safeIdentity(productId) ? { kind: 'waitlist', identity: productId } : null;
  }

  function createSubmissionToken() {
    try {
      if (window.crypto && typeof window.crypto.randomUUID === 'function') {
        return safeToken(window.crypto.randomUUID());
      }
      if (window.crypto && typeof window.crypto.getRandomValues === 'function') {
        var bytes = new Uint8Array(16);
        window.crypto.getRandomValues(bytes);
        return 'alvorn-' + Array.prototype.map.call(bytes, function (byte) {
          return byte.toString(16).padStart(2, '0');
        }).join('');
      }
    } catch (error) {}
    return null;
  }

  function actionToken(element) {
    var explicit = safeToken(element.getAttribute('data-alvorn-analytics-action-token')
      || element.getAttribute('data-alvorn-submission-token'));
    if (explicit) return explicit;
    var identity = successIdentity(element);
    if (!identity) return null;
    try {
      var pending = safeToken(window.sessionStorage.getItem(pendingKey(identity.kind, identity.identity)));
      if (pending) element.setAttribute('data-alvorn-analytics-action-token', pending);
      return pending;
    } catch (error) {
      return null;
    }
  }

  function publishOnce(name, data, token) {
    var payload = data || {};
    var key = token ? 'alvorn:storefront-event:' + name + ':' + token : null;

    if (key) {
      try {
        if (window.sessionStorage.getItem(key)) return false;
      } catch (error) {}
    }
    if (!publish(name, payload)) return false;
    if (key) {
      try {
        window.sessionStorage.setItem(key, '1');
      } catch (error) {}
    }
    return true;
  }

  function within(root, selector) {
    var elements = [];
    if (root && typeof root.matches === 'function' && root.matches(selector)) elements.push(root);
    if (root && typeof root.querySelectorAll === 'function') {
      root.querySelectorAll(selector).forEach(function (element) { elements.push(element); });
    }
    return elements;
  }

  function publishSuccessEvents(root) {
    within(root, '[data-alvorn-newsletter-success], [data-alvorn-waitlist-success]').forEach(function (element) {
      if (element.hasAttribute('data-alvorn-analytics-published')) return;
      if (element.hasAttribute('data-alvorn-newsletter-success')) {
        var source = element.closest('[data-alvorn-newsletter-source]');
        if (publishOnce('newsletter_submit', {
          source: source ? source.getAttribute('data-alvorn-newsletter-source') : null,
          pageType: document.body.dataset.pageType || null
        }, actionToken(element))) element.setAttribute('data-alvorn-analytics-published', '');
        return;
      }

      var priceCents = parseInt(element.getAttribute('data-product-price'), 10);
      if (publishOnce('waitlist_submit', {
        productId: element.getAttribute('data-product-id') || null,
        variantId: element.getAttribute('data-variant-id') || null,
        productHandle: element.getAttribute('data-product-handle') || null,
        price: Number.isFinite(priceCents) ? priceCents / 100 : null,
        currency: element.getAttribute('data-currency') || null,
        pageType: document.body.dataset.pageType || null
      }, actionToken(element))) element.setAttribute('data-alvorn-analytics-published', '');
    });
  }

  function installGlobalInteractions() {
    document.addEventListener('click', function (event) {
      var target = event.target;
      if (!target || typeof target.closest !== 'function') return;

      var trigger = target.closest('[data-alvorn-dialog-open]');
      var handledDialog = false;
      if (trigger) {
        var dialog = document.getElementById(trigger.getAttribute('data-alvorn-dialog-open'));
        if (dialog && typeof dialog.showModal === 'function') {
          event.preventDefault();
          dialog.showModal();
          publish('size_guide_open', {
            productId: trigger.getAttribute('data-product-id') || null,
            productHandle: trigger.getAttribute('data-product-handle') || null,
            pageType: document.body.dataset.pageType || null
          });
          handledDialog = true;
        }
      }

      var sizeGuideLink = target.closest('[data-alvorn-product-size-guide-link]');
      if (!handledDialog && sizeGuideLink) {
        publish('size_guide_open', {
          productId: sizeGuideLink.getAttribute('data-product-id') || null,
          productHandle: sizeGuideLink.getAttribute('data-product-handle') || null,
          pageType: document.body.dataset.pageType || null
        });
      }

      var backdrop = target.closest('dialog[data-alvorn-dialog]');
      if (backdrop && target === backdrop) backdrop.close();
    });

    document.addEventListener('shopify:section:load', function (event) {
      publishSuccessEvents(event.target || document);
    });

    document.addEventListener('submit', function (event) {
      var form = event.target;
      if (!form || typeof form.matches !== 'function') return;
      var identity = formIdentity(form);
      if (!identity) return;
      var token = createSubmissionToken();
      if (!token) return;
      try {
        window.sessionStorage.setItem(pendingKey(identity.kind, identity.identity), token);
      } catch (error) {}
    }, true);
  }

  function init() {
    installGlobalInteractions();
    publishSuccessEvents(document);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
}());
